import React from 'react';
import PropTypes from 'prop-types';
import { ratioToPercentPlus } from '../../lib/format';
var classNames = require('classnames');

export const TwoSidedScoreCard = ({ title, value, oppValue, netValue }) => {
  const oppClassNames = classNames({
    'two-sided-score-card__value': true,
    'color-visitor': true,
  });
  const teamClassNames = classNames({
    'two-sided-score-card__value': true,
    'color-home': true,
  });
  const netClassNames = classNames({
    'two-sided-score-card__value': true,
  });

  return (
    <div className="two-sided-score-card">
      <div className="two-sided-score-card__title" title={title.toUpperCase()}>
        {title.toUpperCase()}
      </div>
      <div className="two-sided-score-card__value-container">
        <div className="two-sided-score-card__value-header">
          <div className="two-sided-score-card__title">Team</div>
          <div className={teamClassNames}>{ratioToPercentPlus(value, 1)}</div>
        </div>
        <div className="two-sided-score-card__value-header">
          <div className="two-sided-score-card__title">Opp</div>
          <div className={oppClassNames}>{ratioToPercentPlus(oppValue, 1)}</div>
        </div>
        <div className="two-sided-score-card__value-header">
          <div className="two-sided-score-card__title">Net</div>
          <div className={netClassNames} style={{ color: '#666' }}>
            {ratioToPercentPlus(netValue, 1)}
          </div>
        </div>
      </div>
    </div>
  );
};

TwoSidedScoreCard.propTypes = {
  title: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  oppValue: PropTypes.number.isRequired,
  netValue: PropTypes.number.isRequired,
};
